// @flow
import * as React from 'react';

import { connect } from 'react-redux';

import { selectTaxesDisplaySetting } from '@gandi/authentication';
import { selectPricingInfos, type Currency } from '@gandi/billing';

import type { TranslatorProps } from '@gandi/translate';
import { Base } from '@gandi/ui';
import { List } from '@gandi/ui/deprecated';

import { selectCorporatePackMonthlyPrice } from '../../../modules/app/selectors/corporatePack';
import type { FullState, Dispatch } from '../../../types';
import { selectors } from '../../modules';
import type { ResultItem } from '../../types';
import BulkAddToCart from '../BulkAddToCart';

import DomainRow from './DomainRow';

const getItemId: (item: ResultItem) => string = item => item.fqdn;

type StateProps = {
  allResults: Array<ResultItem>,
  corporatePackMonthlyPrice: number | void,
  currency: Currency,
  taxesIncluded: boolean,
};

export type Props = {
  dispatch: Dispatch,
  translator: TranslatorProps,
  ...StateProps,
};

function DomainList(props: Props): React.Node {
  const { allResults, translator } = props;

  const showBulk =
    allResults.filter(result => result.isTransferable).length > 1;

  return (
    <Base marginBottom="base">
      <List variant="compact" items={allResults} itemId={getItemId}>
        {(result: ResultItem) => (
          <DomainRow
            corporatePackMonthlyPrice={props.corporatePackMonthlyPrice}
            translator={translator}
            dispatch={props.dispatch}
            currency={props.currency}
            domain={result}
            verbose={props.allResults.length === 1}
            taxesIncluded={props.taxesIncluded}
          />
        )}
      </List>
      {showBulk && <BulkAddToCart translator={translator} />}
    </Base>
  );
}

const mapStateToProps = (state: FullState): StateProps => ({
  allResults: selectors.selectResults(state),
  corporatePackMonthlyPrice: selectCorporatePackMonthlyPrice(state),
  currency: selectPricingInfos(state).currency,
  taxesIncluded: selectTaxesDisplaySetting(state),
});

// $FlowFixMe[signature-verification-failure]
// $FlowFixMe[underconstrained-implicit-instantiation]
export default connect(mapStateToProps)(DomainList);
